import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-user-profile-data-and-privacy',
  standalone: true,
  imports: [],
  templateUrl: './user-profile-data-and-privacy.component.html',
  styleUrl: './user-profile-data-and-privacy.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileDataAndPrivacyComponent {
  // This is the US 2.7.
}
